import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InvitesComponent } from './invites/create-invite/invites.component';
import { AuthGuard } from '../shared/route-guards/auth.guard';
import { BlogComponent } from './blogs/blog/blog.component';
import { FaqsComponent } from './faqs/create-faq/faqs.component';
import { InvitesListComponent } from './invites/invites-list/invites-list.component';
import { BlogListComponent } from './blogs/blog-list/blog-list.component';
import { StaticPageContentComponent } from './static-page-content/static-page-content.component';
import { FaqsListComponent } from './faqs/faqs-list/faqs-list.component';
import { FaqsGroupComponent } from './faqs/faqs-group/faqs-group.component';
import { GeneralSettingComponent } from './general-setting/general-setting.component';
import { AboutComponent } from './about/create-about/about.component';
import { ContactComponent } from './contact/create-contact/contact.component';



const routes: Routes = [
  {
    path: '',
    redirectTo: '/add-invite',
    pathMatch: 'full'
  },
  {
    path: 'invites/add',
    component: InvitesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'resend-invites/:id',
    component: InvitesComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'invites/list',
    component: InvitesListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'blogs/add',
    component: BlogComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'blogs/edit/:id',
    component: BlogComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'blogs/list',
    component: BlogListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'static-page-content',
    component: StaticPageContentComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'general-setting',
    component: GeneralSettingComponent,
    canActivate: [AuthGuard]
  },{
    path: 'faqs/add',
    component: FaqsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'faqs/edit/:id',
    component: FaqsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'faqs/list',
    component: FaqsListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'faqs/group',
    component: FaqsGroupComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'about/add',
    component: AboutComponent,
    canActivate: [AuthGuard]
  },
  { 
    path: 'contact/add',
    component: ContactComponent,
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule { }
